import React, { useContext, useEffect} from 'react'; 
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Add from '../Add/Add'; 
import Delete from '../Delete/Delete';
import Edit from '../Edit/Edit';
import tbl from '../../../../assets/Style/Table.module.css'
import { useAgent } from '../../../../hooks/useAgent';
import { useTranslation } from 'react-i18next';

const AgentList = () => {
  const {t} = useTranslation();
  
  const { agentService } = useAgent(50);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
     agentService.fetchList()
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    agentService.setFilter({
      ...agentService.filter,
      [name]: value
    });
  };
 

  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Agents')}</h1>   
        <Add agentService={agentService} /> 
    </div>


    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
              <th className={cl.id}>#</th>
              <th className={ cl.pad0 }>
                  <input name="name"  placeholder={t('Name')} value={agentService.filter.name} onChange={handleInputChange} /> 
              </th>
              <th>{t('ContractNumber')} </th> 
              <th> </th> 
              </tr>
          </thead>
          <tbody>
              {agentService.items.map((item) =>
                  <tr key={item.id} >
                  < td className={cl.id} >{item.id} </td>
                  <td>{item.name}</td> 
                  <td>{item.number}</td> 
                  <td className={ cl.btntbl }>
                      <div className={ cl.btns }>
                        <Edit agentService={agentService} defaultAgent={item}/>
                        <Delete agentService={agentService} defaultAgent={item}/> 
                      </div>
                  </td>
                  </tr>  
              )}
          </tbody>
      </table>

    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={agentService.total} 
                perPage={agentService.filter.limit} 
                current={agentService.filter.page} 
                paginate={(page) => {
                    agentService.setFilter({
                    ...agentService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                    agentService.setFilter({
                    ...agentService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default AgentList;